<template>
  <v-container fluid class="pt-0">
  <v-card class="pa-2 mb-3 card-r pb-2 shadow-1 ">
    <v-toolbar class="primary mb-3 card-r pl-3 text-white">
      <div class="text-xs-left f-20">My Classes</div>
    </v-toolbar>
    <v-layout wrap class="card-r grey lighten-3">
      <!--<v-flex xs12 class="">-->
      <!--<v-flex xs6 class="">-->
        <!--<div class="pa-2 pb-0">-->
          <!--<v-btn class="secondary text-white card-r no-shadow" to="/createclass"> Add Class</v-btn>-->
        <!--</div>-->
      <!--</v-flex>-->
      <v-flex xs12 class="pt-0">
        <div>
          <v-container fluid grid-list-xl class="pa-3">
            <v-layout row wrap class="">
              <v-flex d-flex lg3 sm6 xs12  v-for="(n, index) in ModulesList">
                <v-card class="no-shadow card-r shadow-1">
                  <!-- <router-link to="/viewclass" class="no-deraction">
                    <v-img src="https://cdn.vuetifyjs.com/images/cards/sunshine.jpg"
                           height="150px"
                           class="card-r">
                      <div class="text-xs-right w-100">
                        <v-btn small class="white" icon to="/EditClass"><v-icon class="f-20">edit</v-icon></v-btn>
                        <v-btn small class="white" icon><v-icon class="f-20">delete</v-icon></v-btn>
                      </div>
                    </v-img>
                  </router-link> -->
                  <!-- <router-link v-bind:to="'/viewclass/'+n.id" class="no-deraction"> -->
                    <v-img v-bind:src="n.image"
                           height="150px"
                           class="card-r">
                      <div class="text-xs-right w-100">
                        <v-btn small class="white" icon :to="/EditClass/+n.id"><v-icon class="f-20">edit</v-icon></v-btn>
                        <!-- <v-btn small class="white" icon><v-icon class="f-20">delete</v-icon></v-btn> -->
                      </div>
                    </v-img>
                  <!-- </router-link> -->

                  <v-card-title primary-title>
                    <div class="text-xs-left">
                      <div class="f-14" style="color: #424242;">{{n.name}}</div>
                      <div style="color: #424242;">
                        <span class="f-12 font-weight-bold text--darken-1">Mins : - </span>
                        <span class="f-12 font-weight-bold text--darken-1">{{n.hours}} mins</span>
                      </div>
                      <div style="color: #424242;">
                      </div>
                      <v-chip v-for="(x,index) in n.tags.slice(0,3)" color="primary" text-color="white">{{x.description.substring(0,4)}}...</v-chip>
                    </div>
                  </v-card-title>
                </v-card>
              </v-flex>
              <v-flex d-flex lg3 sm6 xs12  v-for="(n, index) in ModulesList">
                <v-card class="no-shadow card-r shadow-1">
                  <!-- <router-link to="/viewclass" class="no-deraction">
                    <v-img src="https://cdn.vuetifyjs.com/images/cards/sunshine.jpg"
                           height="150px"
                           class="card-r">
                      <div class="text-xs-right w-100">
                        <v-btn small class="white" icon to="/EditClass"><v-icon class="f-20">edit</v-icon></v-btn>
                        <v-btn small class="white" icon><v-icon class="f-20">delete</v-icon></v-btn>
                      </div>
                    </v-img>
                  </router-link> -->
                  <!-- <router-link v-bind:to="'/viewclass/'+n.id" class="no-deraction"> -->
                    <v-img v-bind:src="n.image"
                           height="150px"
                           class="card-r">
                      <div class="text-xs-right w-100">
                        <v-btn small class="white" icon :to="/EditClass/+n.id"><v-icon class="f-20">edit</v-icon></v-btn>
                        <!-- <v-btn small class="white" icon><v-icon class="f-20">delete</v-icon></v-btn> -->
                      </div>
                    </v-img>
                  <!-- </router-link> -->

                  <v-card-title primary-title>
                    <div class="text-xs-left">
                      <div class="f-14" style="color: #424242;">{{n.name}}</div>
                      <div style="color: #424242;">
                        <span class="f-12 font-weight-bold text--darken-1">Mins : - </span>
                        <span class="f-12 font-weight-bold text--darken-1">{{n.hours}} mins</span>
                      </div>
                      <div style="color: #424242;">
                      </div>
                      <v-chip v-for="(x,index) in n.tags.slice(0,3)" color="primary" text-color="white">{{x.description.substring(0,4)}}...</v-chip>
                    </div>
                  </v-card-title>
                </v-card>
              </v-flex>

              <v-flex d-flex lg3 sm6 xs12  v-for="(n, index) in ModulesList">
                <v-card class="no-shadow card-r shadow-1">
                  <!-- <router-link to="/viewclass" class="no-deraction">
                    <v-img src="https://cdn.vuetifyjs.com/images/cards/sunshine.jpg"
                           height="150px"
                           class="card-r">
                      <div class="text-xs-right w-100">
                        <v-btn small class="white" icon to="/EditClass"><v-icon class="f-20">edit</v-icon></v-btn>
                        <v-btn small class="white" icon><v-icon class="f-20">delete</v-icon></v-btn>
                      </div>
                    </v-img>
                  </router-link> -->
                  <!-- <router-link v-bind:to="'/viewclass/'+n.id" class="no-deraction"> -->
                    <v-img v-bind:src="n.image"
                           height="150px"
                           class="card-r">
                      <div class="text-xs-right w-100">
                        <v-btn small class="white" icon :to="/EditClass/+n.id"><v-icon class="f-20">edit</v-icon></v-btn>
                        <!-- <v-btn small class="white" icon><v-icon class="f-20">delete</v-icon></v-btn> -->
                      </div>
                    </v-img>
                  <!-- </router-link> -->

                  <v-card-title primary-title>
                    <div class="text-xs-left">
                      <div class="f-14" style="color: #424242;">{{n.name}}</div>
                      <div style="color: #424242;">
                        <span class="f-12 font-weight-bold text--darken-1">Mins : - </span>
                        <span class="f-12 font-weight-bold text--darken-1">{{n.hours}} mins</span>
                      </div>
                      <div style="color: #424242;">
                      </div>
                      <v-chip v-for="(x,index) in n.tags.slice(0,3)" color="primary" text-color="white">{{x.description.substring(0,4)}}...</v-chip>
                    </div>
                  </v-card-title>
                </v-card>
              </v-flex>

              <v-flex d-flex lg3 sm6 xs12  v-for="(n, index) in ModulesList">
                <v-card class="no-shadow card-r shadow-1">
                  <!-- <router-link to="/viewclass" class="no-deraction">
                    <v-img src="https://cdn.vuetifyjs.com/images/cards/sunshine.jpg"
                           height="150px"
                           class="card-r">
                      <div class="text-xs-right w-100">
                        <v-btn small class="white" icon to="/EditClass"><v-icon class="f-20">edit</v-icon></v-btn>
                        <v-btn small class="white" icon><v-icon class="f-20">delete</v-icon></v-btn>
                      </div>
                    </v-img>
                  </router-link> -->
                  <!-- <router-link v-bind:to="'/viewclass/'+n.id" class="no-deraction"> -->
                    <v-img v-bind:src="n.image"
                           height="150px"
                           class="card-r">
                      <div class="text-xs-right w-100">
                        <v-btn small class="white" icon :to="/EditClass/+n.id"><v-icon class="f-20">edit</v-icon></v-btn>
                        <!-- <v-btn small class="white" icon><v-icon class="f-20">delete</v-icon></v-btn> -->
                      </div>
                    </v-img>
                  <!-- </router-link> -->

                  <v-card-title primary-title>
                    <div class="text-xs-left">
                      <div class="f-14" style="color: #424242;">{{n.name}}</div>
                      <div style="color: #424242;">
                        <span class="f-12 font-weight-bold text--darken-1">Mins : - </span>
                        <span class="f-12 font-weight-bold text--darken-1">{{n.hours}} mins</span>
                      </div>
                      <div style="color: #424242;">
                      </div>
                      <v-chip v-for="(x,index) in n.tags.slice(0,3)" color="primary" text-color="white">{{x.description.substring(0,4)}}...</v-chip>
                    </div>
                  </v-card-title>
                </v-card>
              </v-flex>

            </v-layout>
          </v-container>
        </div>
      </v-flex>
    </v-layout>
  </v-card>
  </v-container>
</template>
<style>
  /*.hover-styl:hover {*/
    /*color: #ffffff!important;*/
    /*-ms-transform: scale(1.5); !* IE 9 *!*/
    /*-webkit-transform: scale(1.5); !* Safari 3-8 *!*/
    /*transform: scale(1.05);*/
    /*padding: 10px 10px 10px 10px ;*/
    /*margin-top: -10px;*/
    /*transition: transform 0.5s;*/
    /*box-shadow: 0 10px 33px 4px rgba(1,0,4,0.2), -1px -1px 0px 0 rgba(0, 0, 0, 0.13), 1px 8px 11px 5px rgba(0,0,0,.12)!important;*/
  /*}*/
/*.dd:hover{*/
  /*-ms-transform: scale(1); !* IE 9 *!*/
  /*-webkit-transform: scale(1.5); !* Safari 3-8 *!*/
  /*transform: scale(1.05);*/
  /*transition: transform 1s;*/
/*}*/
  /*.hover-styl:hover .effect {*/
    /*display: block;*/
  /*}*/

  /*.effect {*/
    /*padding-top: 7px;*/
    /*padding-right: 7px;*/
    /*position: absolute;*/
    /*right: 0;*/
    /*top: 0;*/
    /*display: none;*/
  /*}*/
  /*.effect a {*/
    /*color: #000;*/
  /*}*/




  .view-package-main-container{
    color: #7f7f7f ;
  }
  .view-package-main-container .v-carousel__controls{
    background-color: transparent !important;
  }
  .view-package-carousel .v-btn:before{
    background-color: #0069b3 !important;
  }
  .view-package-carousel .fa-circle:before{
    color: #7f7f7f!important;
  }
  .view-package-main-container h1{
    color: #454545!important;
    font-weight: 500;
  }
  .view-package-main-container p{
    color: #7f7f7f !important;
    text-align: justify !important;
    font-weight: 100;
  }
  .view-content-card{
    color: #7f7f7f !important;
  }
  .view-button {
    background-color: #0051a0 !important;
  }
  .v-dialog{
    box-shadow: none!important;
  }
</style>

<script>
/* eslint-disable */
import ConfirmDelete from "./ConfirmDelete";
import { mapState, dispatch } from "vuex";
import api from "@/utils/backend-api"
// import { BulletListLoader } from 'vue-content-loader'
export default {
  data: () => ({
    loading:false,
    tags:'',
    show: false,
    dialog: false,
    ModulesList: [],
    Minutes:['all',45,90,135,180,225],
    selectedMinute:'',
    selectedClub:'',
    filteredClasses:[],
    selectedClasses:[],
    alertType:'',
    msg:'',
  }),
  created:function(){
    this.loadClubClasses()
  },
  methods:{
    loadClubClasses(){
      let self=this
      api.postData('driver/viewModuleTemplate')
      .then(res => {
        self.ModulesList = res.data;
      })
    },
  },
  components: {
    ConfirmDelete
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/pages/classes/Classes.vue